import { type MouseEventHandler } from 'react';
import clsx from 'clsx';

import styles from './Icon.module.scss';

export interface IconProps {
    className?: string;
    component?: React.ComponentType;
    inheritColors?: boolean;
    name?: string;
    onClick?: MouseEventHandler<HTMLSpanElement>;
    svgProps?: React.SVGProps<SVGSVGElement>;
}

export const Icon = ({
    className,
    component: Component,
    inheritColors,
    name,
    onClick,
    svgProps,
    ...rest
}: IconProps) => {
    if (!Component) {
        return null;
    }

    return (
        <Component
            className={clsx(
                'Icon',
                name && `${name}-icon`,
                styles['Icon'],
                onClick && styles['Icon--clickable'],
                inheritColors !== false && styles['Icon--inherit-colors'],
                className,
            )}
            onClick={onClick}
            viewBox="0 0 24 24"
            {...rest}
            {...svgProps}
        />
    );
};
